import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Box } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
export var Card = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: 200ms all ease-in-out;\n  overflow: hidden;\n  &:hover {\n    box-shadow: ", ";\n  }\n"])), themeGet("shadows.box"));